import getEnvironmentVar from './getEnvironmentVar'

const SYMBOLS_TO_BE_RENAMED = [
  '1INCH',
  'AAVE',
  'BTC',
  'DAI',
  'ETH',
  'LINK',
  'SNX',
  'UNI',
  'YFI',
  'DOT',
  'BNB',
  'AVAX',
  'CRV',
  'LTC',
  'BCH',
  'DOGE',
  'CAKE',
  'ADA',
  'XRP',
  'XLM',
  'DASH',
  'XMR',
  'ATOM',
  'SUSHI',
  'BADGER',
  'LRC',
  'BAL',
  'RUNE',
  'GRT',
  'FIL',
  'XEM',
  'HEGIC',
  'SOL',
  'BNT',
  'DODO',
  'MKR',
  'NEO',
  'EOS',
  'MIOTA',
  'XTZ',
  'THETA',
  'COMP',
  'TRX',
]

const CLEANEDUP_SYMBOLS = {}

SYMBOLS_TO_BE_RENAMED.forEach((symbol) => {
  const key = getEnvironmentVar(symbol + '_ADDRESS').toLowerCase()
  // note: on testnet, not all Tokens are defined
  if (key) {
    CLEANEDUP_SYMBOLS[key] = symbol
  }
})

const getSymbol = (token) => {
  return CLEANEDUP_SYMBOLS[token.id] || token.symbol
}

export default getSymbol
